import { render } from "./DesktopMenuBar.vue?vue&type=template&id=8dfe3c1c&scoped=true"
import script from "./DesktopMenuBar.vue?vue&type=script&lang=js"
export * from "./DesktopMenuBar.vue?vue&type=script&lang=js"

import "./DesktopMenuBar.vue?vue&type=style&index=0&id=8dfe3c1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfe3c1c"]])

export default __exports__